import { Controller } from "@hotwired/stimulus";

// Swaps the visible curriculum for the grade tab that was clicked. Bootstrap's
// pill plugin moves the "active" class between the tabs on its own.
export default class extends Controller {
  static targets = ["content", "grade"];

  show({ params: { grade } }) {
    const source = this.gradeTargets.find(
      (element) => element.dataset.grade === grade,
    );
    if (source) this.contentTarget.innerHTML = source.innerHTML;
  }
}
